<template>
  <div class="supervisor-info-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="工长详情" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="supervisor-detail">
      <div class="top" style="background: #c4a183">
        <img class="supervisor-avatar" style="left: 0.26rem;" :src="imgUrl + supervisor.avatar">
        <img class="supervisor-avatar-platform" src="../../assets/icon-platform-gongzhang.png" alt="">
        <div class="case-info">
          <div class="label">案例</div>
          <div class="num">{{supervisor.projectCount}}</div>
          <div class="label">施工中</div>
          <div class="num">{{supervisor.projectingCount-(supervisor.preCompletedCount||0)}}</div>
          <!-- <div class="label">待竣工</div>
          <div class="num">{{supervisor.preCompletedCount||0}}</div> -->
        </div>
      </div>
      <div class="bottom">
        <div class="name" style="margin-left: -0.45rem;margin-top: 0.55rem;">{{supervisor.name}}</div>
        <div class="appointment-info" style="background: #f7f6f2;color: #c4a183">
          <div class="label">已预约</div>
          <div class="num first">{{supervisor.appointmentCount}}</div>
          <div class="label">可预约</div>
          <div class="num">{{supervisor.spares}}</div>
        </div>
      </div>
      <div class="bottom-three">
        <div style="display:flex;align-items:center">
          <img src="../../assets/icon-build-three.png" alt="" style="width: 0.4rem;margin-right:3px">
          <div>标准化施工</div>
        </div>
        <div style="display:flex;align-items:center">
          <img src="../../assets/icon-build-two.png" alt="" style="width: 0.4rem;margin-right:3px">
          <div>先施工后付款</div>
        </div>
        <div style="display:flex;align-items:center">
          <img src="../../assets/icon-build-one.png" alt="" style="width: 0.4rem;margin-right:3px">
          <div>精准预算零增项</div>
        </div>
      </div>
    </div>
    <div class="supervisor-detail-tab">
      <div class="tab-item" @click="isLabel(0)" :class = "{'selected':isLabelNum == 0}">工长自述</div>
      <div class="tab-item" @click="isLabel(1)" :class = "{'selected':isLabelNum == 1}">施工案例</div>
      <div class="tab-item" @click="isLabel(2)" :class = "{'selected':isLabelNum == 2}">工长评价</div>
    </div>
    <div class="intro" v-if="isLabelNum == 0">
      <div class="content" v-if="supervisor.intro.length > 0">{{supervisor.intro}}</div>
    </div>
      <div class="project-list" v-if="isLabelNum == 1">
        <div class="project-item" v-for="(caseProject,index) in caseList" v-if="index < 4" @click="openCaseProject(caseProject.projectId)" style="box-shadow:none;">
          <img v-if="caseProject.onestopProject.cover" :src="imgUrl + caseProject.onestopProject.cover | ossProcess(690, 320)">
          <img v-else src="../../assets/icon-project-default-cover.png">
          <div class="project-info">
            <div class="name">{{caseProject.onestopProjectName}}</div>
          </div>
          <div class="project-status">
            <div v-if="caseProject.status == '4'" class="state">正在施工 </div>
            <div v-if="caseProject.status == '5'" class="state">验收中</div>
            <div v-if="caseProject.status == '6'" class="state">已竣工</div>
            <div>{{caseProject.onestopProject.houseLayout}}</div>
          </div> 
        </div>
        <div v-if="caseList.length == 0" class="black-page">
          <img src="../../assets/icon-no-img.png">
          <div class="tip">暂无该工长的相关案例!</div>
        </div>
        <div class="loading-more" @click="openCaseList()">
          <!-- <span>查看更多案例{{caseList.length - 7}}个</span> -->
          <span>查看更多案例</span>
          <img class="more" src="../../assets/icon-more.png">
        </div>
      </div>
      <div class="evaluate-list" v-if="isLabelNum == 2">
        <div class="evaluate-item" v-for="evaluate in customerEvaluateList">
          <img v-if="evaluate.customerAvatar" :src="evaluate.customerAvatar">
          <img v-if="!evaluate.customerAvatar" src="../../assets/icon/icon-defualt-avatar.png">
          <div class="evaluate-info">
            <div class="name">{{evaluate.customerName}}</div>
            <div class="date">{{evaluate.createTime | simpleDayFilter}}
              <img v-if="evaluate.update" class="icon-evaluate-edit-btn" @click="toCustomerEvaluateEdit(evaluate.id)" src="../../assets/icon-evaluate-reEdit.png"/>
            </div>
            <div class="content">{{evaluate.content}}</div>
          </div>
          <div class="evaluate-score">
            <div class="score">{{evaluate.score | score}}</div>
          </div>
        </div>
        <div v-if="customerEvaluateList.length == 0" class="black-page">
          <img src="../../assets/icon-no-img.png">
          <div class="tip">暂无该工长的相关评价信息!</div>
        </div>
      </div>
      <div class="appointment-btn" @click="openGangmasterReservation(supervisor)">预约</div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui'
  import {imgUrl,shareIcon} from '../../config'
  import Header from '../../components/header/Header'
  import SupervisorService from '../../service/SupervisorService'
  import onestopProjectSupervisorService from '../../service/onestop/OnestopProjectSupervisorService'
  import EvaluateService from '../../service/customer/EvaluateService'
  import shareService from '../../service/share/ShareService'

  export default {
    name: 'GangmasterDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        isLabelNum:0,
        supervisorId:'',
        supervisorType:'2',
        supervisor:{intro:''},
        customerEvaluateList:[],
        caseList:[],
        guaranteeList:[],
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        isWechatBrowser:this.$verfyBrowserType(),
        supervisorName:''
      }
    },
    created(){
      this.supervisorId = this.$route.query.supervisorId;
      this.supervisorName = this.$route.query.supervisorName;
      if(this.global.isLabelNum){
        this.isLabelNum = this.global.isLabelNum;
        this.isLabel(this.isLabelNum);
        this.global.isLabelNum = 0;
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getSupervisorInfo(this.supervisorId);
      this.initWechatShare();
    },
    methods: {
      isLabel(num){
        if(num == 1){
          this.isLabelNum=1;
          this.getCaseList();
        }else if(num == 2){
          this.isLabelNum=2;
          this.getEvaluateList();
        }else {
          this.isLabelNum=0;
        }
      },
      openCaseList(){
        this.global.isLabelNum = this.isLabelNum;
        this.$router.push({name:'CaseList',query:{supervisorId:this.supervisorId, supervisorType:this.supervisorType}});
      },
      openCaseProject(id){
        this.global.isLabelNum = this.isLabelNum;
        const h5Url = `/project?id=${id}`
        if(this.global.isMiniProgrm){
          wx.miniProgram.navigateTo({
            url: `/pages/h5/webview/index?path=${encodeURIComponent(h5Url)}&nbBackgroundColor=#384157`,
          })
        }else{
          this.$router.push({name:'Project',query:{id}});
        }
      },
      toCustomerEvaluateEdit(id){
        this.global.isLabelNum = this.isLabelNum;
        this.$router.push({name:'CustomerEvaluateEdit',query:{id}});
      },
      openGangmasterReservation(gangmaster){
        this.global.isLabelNum = this.isLabelNum;
        if(gangmaster.appointmentSwitch != '1'){
          Toast('该工长暂时不接受预约!');
        }else if(gangmaster.appointmentSwitch == '1' && gangmaster.spares == 0){
          Toast('该工长预约已满!');
        }else {
          if(!!this.global.isMiniProgrm ){
            wx.miniProgram.navigateTo({url: `/pages/gangmaster/reservation?id=${gangmaster.id}&companyId=${gangmaster.companyId}&deposit=${gangmaster.deposit}&supervisorName=${gangmaster.name}`});
          }else {
            this.$router.push({name:'GangmasterReservation',query:{id:gangmaster.id, companyId:gangmaster.companyId, supervisorName:gangmaster.name, deposit:gangmaster.deposit}});
          }
        }
      },
      async initWechatShare(){
        let title = "推荐水木家居商城优选工长";
        let desc = "我在水木家居商城找到一位好工长“"+this.supervisorName+"”，推荐给想装修的朋友！";
        let link = window.location.href;
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      async getSupervisorInfo(id){
        var result=await SupervisorService.getSupervisorDetail(id);
        if(result.code == 0){
           this.supervisor = result.data;
           console.info(this.supervisor)
        }else {
          Toast('获取工长详细信息失败');
        }
      },
      async getEvaluateList(){
        let companyId = '';
        if(this.supervisor.companyId){
          companyId = this.supervisor.companyId
        }
        var result = await EvaluateService.evaluateList(this.supervisorId,companyId,'',this.supervisorType,'1');
        if(result.code == 0){
           this.customerEvaluateList = result.data;
          for (let evaluate of this.customerEvaluateList) {
            evaluate.customerName = evaluate.onestopProject.customerName;
            if(evaluate.customerUser != null){
              evaluate.customerAvatar = evaluate.customerUser.avatarUrl;
            }else if(evaluate.customerAvatar){
              evaluate.customerAvatar = this.imgUrl + evaluate.customerAvatar;
            }
            let projectName = evaluate.onestopProject.name;
            if(projectName && projectName.length > 17){
              projectName = projectName.substring(0,14) + '...';
            }
            this.$set(evaluate,'projectName',projectName);
          }
        }else {
          Toast('获取工长评价信息失败');
        }
      },
      async getCaseList(){
        var result = await onestopProjectSupervisorService.cases(this.supervisorId);
        if(result.code == 0){
           this.caseList = [];
          for(let caseProject of result.data.result){
            if(caseProject.onestopProjectName && caseProject.onestopProjectName.length > 10){
              caseProject.onestopProjectName = caseProject.onestopProjectName.substring(0,9) + '...';
            }
            if(caseProject.status != 7){
              this.caseList.push(caseProject);
            }
          }
        }else {
          Toast('获取工长案例信息失败');
        }
      },
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/supervisor-detail.scss';
  .foreman-view{
    .supervisor-detail{
      border-bottom: solid 10px #f7f6f5;
    }
  }
  .project-info {
    .name {
      margin-right: 0 !important;
    }
  }
  .bottom-three{
    padding: 16px 0 0.2rem 0;
    margin: 0 0.5rem 0 0.5rem;
    display: flex;
    justify-content: space-between;
    border-top: solid 1px #eeeeee;
    font-size: 13px;
  }
</style>

